import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunityServiceInfoComponent } from './community-service-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { DialogModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ButtonModule, ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { NgxPrintModule } from 'ngx-print';
import { CommunityServiceInfoDetailComponent } from './community-service-info-detail/community-service-info-detail.component';
import { CommunityServiceCorrectionComponent } from './community-service-correction/community-service-correction.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  declarations: [
    CommunityServiceInfoComponent,
    CommunityServiceInfoDetailComponent,
    CommunityServiceCorrectionComponent
  ],
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    CommonModule,
    PipesModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    ButtonsModule,
    NgxPrintModule,
    DropDownsModule,
    InputsModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownButtonModule
  ],
  exports: [
    CommunityServiceInfoComponent,
    CommunityServiceInfoDetailComponent,
    CommunityServiceCorrectionComponent,
    DropDownsModule,
    InputsModule
  ]
})
export class CommunityServiceInfoModule { }
